export default {
    SERVER: 'https://testapi.lincora.ru/',
    WEBSOCKET: 'wss://testapi.lincora.ru/ws',
    CHAT_SERVER: 'https://testchat.lincora.ru/',
    CHAT_WEBSOCKET: 'wss://testchat.lincora.ru/chat/',
    MAX_SPACE: 262144000, // bytes
    TOAST_CONFIG_SUCCESS: {
        hideProgressBar: true,
        timeout: 2500,
        showIcon: false,
        showCloseButton: false,
        swipeClose: false,
        type: 'success'
    },    
    TOAST_CONFIG_WARNING: {
        hideProgressBar: true,
        timeout: 2500,
        showIcon: false,
        showCloseButton: false,
        swipeClose: false,
        type: 'warning'
    },
    TOAST_CONFIG_ERROR: {
        hideProgressBar: true,
        timeout: 2500,
        showIcon: false,
        showCloseButton: false,
        swipeClose: false,
        type: 'danger'
    }    
}